import React from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import { privateMessagingRouterLink} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";


const PrivateMessagingAppSidebar= (props) =>
{
    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">

                    <AppSidebarGroup title='View' default='private'>
                        <AppSidebarMenuItem link={privateMessagingRouterLink(null)} title='Private Messages' iconName='icon-files' name='private' />
                    </AppSidebarGroup>

                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default PrivateMessagingAppSidebar;
